import styled from 'styled-components/macro'

const PageContainer = styled.div({
  maxWidth: '780px',
  margin: '0 auto',
})

export default PageContainer
